(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name webAgro1App.controller:HistoricoCorrecaoSoloCtrl
   * @description
   * # HistoricoCorrecaoSoloCtrl
   * Controller of the webAgro1App
   */
  angular
    .module('webAgro1App')
    .controller('HistoricoCorrecaoSoloCtrl', HistoricoCorrecaoSoloCtrl);

  HistoricoCorrecaoSoloCtrl.$inject = [
    '$scope',
    '$rootScope',
    'LoadingService',
    'PeriodSelectService',
    'filterFilter',
    'HistoricosService',
    'MessagesService',
    'CorrecoesSoloService',
    '$q',
    'RecomendacoesService',
    'MapaService',
    '$http',
    'GoogleMapsService',
    'PeriodosService',
    'DrawPolygonsObjectService',
    '$route',
    '$routeParams',
    'LeafletService',
    'TrackingService',
    'AplicacoesService',
    '$anchorScroll',
    'DecimalsService'
  ];

  // eslint-disable-next-line max-lines-per-function,max-params
  function HistoricoCorrecaoSoloCtrl($scope, $rootScope, LoadingService,
    PeriodSelectService, filterFilter, HistoricosService,
    MessagesService, CorrecoesSoloService, $q,
    RecomendacoesService, MapaService, $http,
    GoogleMapsService, PeriodosService, DrawPolygonsObjectService,
    $route, $routeParams, LeafletService,
    TrackingService, AplicacoesService, $anchorScroll, DecimalsService) {
    let hasPage = true;
    let inProgress = true;
    let requestId = 0;
    let percentualRecomendadoAplicado;
    let activePolygons = [];

    //////////////////////////////////////////
    // Controller data
    $scope.initialized = false;
    $scope.glebas = $rootScope.currentPropriedade.glebas || [];
    $scope.applications = [];
    $scope.correcoesFilters = {};
    $scope.filtroPeriodo = {};
    $scope.loadingAplicacoes = false;
    $scope.statusFilter = { integrado: false, erro: false, pendente: false };

    //////////////////////////////////////////
    // Bindable methods
    $scope.initializeVariables = initializeVariables;
    $scope.initialize = initialize;
    $scope.resetPeriodsFilter = resetPeriodsFilter;
    $scope.setValoresComBaseNoHistorico = setValoresComBaseNoHistorico;
    $scope.getApplications = getApplications;
    $scope.openApplicationDetail = openApplicationDetail;
    $scope.getSubCardApplicationId = getSubCardApplicationId;
    $scope.getCardApplicationId = getCardApplicationId;
    $scope.setPositionSubCardCorrecao = setPositionSubCardCorrecao;
    $scope.setClassificacaoAplicadoRecomendado = setClassificacaoAplicadoRecomendado;
    $scope.openRecommendationDetail = openRecommendationDetail;
    $scope.isOpened = isOpened;
    $scope.getRecommendationDataInicio = getRecommendationDataInicio;
    $scope.getRecommendationDataFim = getRecommendationDataFim;
    $scope.canManage = canManage;
    $scope.resetMap = resetMap;
    $scope.showRastroMaquina = showRastroMaquina;
    $scope.showAreaDemarcada = showAreaDemarcada;
    $scope.setFilterAttribute = setFilterAttribute;
    $scope.setPeriodo = setPeriodo;
    $scope.openPeriodsFilter = openPeriodsFilter;
    $scope.toggleStatusFilter = toggleStatusFilter;
    $scope.getStatusFilterLabel = getStatusFilterLabel;
    $scope.remover = remover;
    $scope.getRecommendationProducts = getRecommendationProducts;
    $scope.calculateTotalProduto = calculateTotalProduto;
    $scope.edit = edit;

    //////////////////////////////////////////
    // Function declarations

    function initializeVariables() {
      $scope.correcoesFilters.page = 1;
      hasPage = true;
      inProgress = false;
      requestId += 1;
      $scope.applications = [];
      percentualRecomendadoAplicado = $rootScope.parametros.percentual_recomendado_aplicado ||
        PERCENTUAL_TOLERANCIA_PADRAO_RECOMENDADO_APLICADO;
    }

    function initialize() {
      if (!$scope.initialized) {
        $scope.initialized = true;
        $scope.loadingAplicacoes = true;
        $scope.correcoesFilters = {
          tipo: 'correcaoSolo'
        };

        $scope.initializeVariables();
        $scope.resetPeriodsFilter();
        $scope.filtroPeriodo = PeriodSelectService.getFilterPeriodo($scope.$root.safras);
        $scope.setValoresComBaseNoHistorico();

        loadData();

        const selectedGleba = $routeParams.gleba || $routeParams.activeGleba;
        if (selectedGleba) {
          $scope.correcoesFilters.gleba = $scope.$root.currentPropriedade.glebas
            .find((gleba) => gleba.id === +selectedGleba);
        }

        $scope.getApplications();
        AplicacoesService.closeOpenRecommendationsModal(closeRecommendations);
      }
    }

    function loadData() {
      PeriodosService.list().then(function(result) {
        $scope.epocas = result.data;
      }, function(error) {
        console.error('Erro ao listar períodos das culturas', error);
      });

      $scope.loadingGrupoInsumo = true;

      HistoricosService.listGruposInsumos()
        .then(function(data) {
          $scope.filtroGruposInsumos = data.data || [];
        })
        .catch(function() {
          MessagesService.alert('Não foi possível consultar os dados.');
        })
        .finally(function() {
          $scope.loadingGrupoInsumo = false;
        });
    }

    function setValoresComBaseNoHistorico() {
      let filteredPeriod;

      if ($routeParams.date || $routeParams.historyDate) {
        filteredPeriod = HistoricosService.getFilteredPeriod({
          data: $routeParams.date || $routeParams.historyDate
        }, $scope.safras);
        $scope.correcoesFilters.dataInicial = filteredPeriod.dataInicial;
        $scope.correcoesFilters.dataFinal = filteredPeriod.dataFinal;
        $scope.period = filteredPeriod.periodo;
      }
      if ($routeParams.activeGleba) {
        $scope.correcoesFilters.gleba = filterFilter($scope.glebas, { id: +$routeParams.activeGleba }, true)[0];
      }
    }

    function resetPeriodsFilter() {
      $scope.correcoesFilters.dataInicial = null;
      $scope.correcoesFilters.dataFinal = null;
      $scope.period = {
        eventDates: [],
        periodo: ''
      };
    }

    function getApplications() {
      const hasFilterPage = $scope.correcoesFilters && $scope.correcoesFilters.page;

      if (hasFilterPage && hasPage && !inProgress) {
        $scope.loadingAplicacoes = true;
        inProgress = true;

        const promises = [
          CorrecoesSoloService.list($scope.correcoesFilters)
        ];

        if (!$scope.applications.length) {
          promises.push(CorrecoesSoloService.getStatusCorrecaoGlebas($scope.correcoesFilters));
        }

        processApplications(promises, requestId);
      }
    }

    // eslint-disable-next-line max-lines-per-function
    function processApplications(promises, currentRequestId) {
      $q.all(promises)
        .then((data) => {
          if (currentRequestId !== requestId) {
            return;
          }
          const dados = data[0].data || [];
          hasPage = _.get(data[0], 'pages.pagination.next', 0) > $scope.correcoesFilters.page;

          if (dados.length > 0) {
            $scope.correcoesFilters.page++;

            dados.forEach((dado) => {
              dado.adubacaoSistema = dado.cd_operacao === _.get($rootScope.parametros.operacao_adubacao_sistema, 'id');
            });
            $scope.applications = $scope.applications.concat(dados);
            closeApplicationsAreaVisivel();
            clearMapPolygons();

            if ($scope.applications.length === 1) {
              $scope.openApplicationDetail(null, $scope.applications[0]);
            } else if ($routeParams.activeApplication) {
              const app = $scope.applications.find((a) => +a.id === +$routeParams.activeApplication);

              app ? $scope.openApplicationDetail(null, app) : updateRouteParams();
            }
          }
        })
        .catch(() => {
          if (currentRequestId === requestId) {
            MessagesService.alert('Não foi possível buscar a lista de correções de solo.');
          }
        })
        .finally(function() {
          if (currentRequestId === requestId) {
            inProgress = false;
            $scope.loadingAplicacoes = false;
          }
        });
    }

    // eslint-disable-next-line max-lines-per-function
    function openApplicationDetail(event, correcao) {
      if (event) {
        stopPropagation(event);
        preventDefault(event);
      }

      if (!correcao || !correcao.id) {
        return;
      }

      closeApplicationsAreaVisivel();
      correcao.openRecommendation = false;
      correcao.classificacao = {};

      if (!correcao.open) {
        updateRouteParams(correcao.id);
        correcao.loading = true;
        correcao.allData = {};
        CorrecoesSoloService.get(correcao.id).then(function({ data }) {
          correcao.allData = data || {};
          $anchorScroll($scope.getCardApplicationId(correcao));
        })
          .catch(function() {
            MessagesService.alert('Não foi possível consultar a correção de solo.');
          })
          .finally(function() {
            correcao.loading = false;
            correcao.open = true;
          });
      } else {
        correcao.open = false;
        updateRouteParams();
      }
      $scope.resetMap();
    }

    function updateRouteParams(id = null) {
      $route.updateParams({
        activeApplication: id
      });
    }

    function openRecommendationDetail(event, correcao) {
      stopPropagation(event);
      preventDefault(event);

      if (!correcao || !correcao.id || !correcao.open) {
        return;
      }

      if (!correcao.openRecommendation) {
        correcao.openRecommendation = !correcao.openRecommendation;
        correcao.recommendation = {};
        $scope.setPositionSubCardCorrecao(correcao);

        if (_.get(correcao, 'allData.atributo.recomendacao_id')) {
          correcao.loadingRecommendation = true;
          RecomendacoesService.getCorrecao(correcao.allData.atributo.recomendacao_id).then(function(data) {
            correcao.recommendation = data.data || {};
            correcao.recommendation.gleba =
              filterFilter(correcao.recommendation.glebas, { gleba: { id: correcao.gleba.id } }, true)[0];
            $scope.setClassificacaoAplicadoRecomendado(correcao);
          })
            .catch(function(e) {
              MessagesService.alert('Não foi possível consultar a recomendação.');
              console.error('Erro ao consultar recomendação', e);
            })
            .finally(function() {
              correcao.loadingRecommendation = false;
            });
        }
      } else {
        correcao.openRecommendation = !correcao.openRecommendation;
      }
    }

    function setPositionSubCardCorrecao(correcao) {
      const card = $(`#${$scope.getCardApplicationId(correcao)}`);
      const subCard = $(`#${$scope.getSubCardApplicationId(correcao)}`);

      subCard.css({
        'min-height': `${card.height()}px`,
        width: `${card.width()}px`,
        top: `${card.offset().top}px`
      });
    }

    function getSubCardApplicationId(correcao) {
      return `subcard-correcao-${correcao.id}`;
    }

    function getCardApplicationId(correcao) {
      return `correcao-${correcao.id}`;
    }

    /* eslint-disable-next-line max-lines-per-function */
    function setClassificacaoAplicadoRecomendado(correcao) {
      function getExisteDiferencaDoseRecomendadoAplicado(recomendado, aplicado) {
        if (!recomendado.produto) {
          return true;
        }
        return Math.abs(((aplicado.qt_dose * 100) / recomendado.qt_dose) - 100) > percentualRecomendadoAplicado;
      }

      if (!correcao.recommendation) {
        return;
      }

      correcao.classificacao = {
        area: correcao.area !== correcao.recommendation.gleba.area_recomendada,
        dtIni: correcao.dt_ini < correcao.recommendation.data_inicio ||
          correcao.dt_ini > correcao.recommendation.data_termino,
        dtFim: correcao.dt_fim < correcao.recommendation.data_inicio ||
          correcao.dt_fim > correcao.recommendation.data_termino,
        velocidadeVento: (
          +correcao.recommendation.parametro.velocidade_maxima_vento <
          +correcao.allData.atributo.velocidade_maxima_vento
        )
      };
      correcao.classificacao.itensAplicacao = correcao.allData.itens.map(function(produto) {
        const produtoRecomendacao = filterFilter(
          correcao.recommendation.produtos,
          { produto: { item_id: produto.item_codigo } },
          true
        )[0] || {};

        return {
          produto: !(produtoRecomendacao.produto && produtoRecomendacao.produto.item_id),
          dose: getExisteDiferencaDoseRecomendadoAplicado(produtoRecomendacao, produto)
        };
      });

      correcao.classificacao.insumosRecomendacao = correcao.recommendation.produtos.map(function(produto) {
        const produtoAplicado = filterFilter(
          correcao.allData.itens,
          { item_codigo: produto.produto.item_id },
          true
        )[0] || {};
        return {
          produto: !produtoAplicado.item_codigo,
          aplicado: AplicacoesService.getAppliedPercentage(correcao.recommendation, produto, produtoAplicado)
        };
      });
    }
    /* eslint-enable */

    function isOpened(correcao) {
      return correcao.open && correcao.openRecommendation;
    }

    function getRecommendationDataInicio(correcao) {
      return correcao.recommendation.data_inicio;
    }

    function getRecommendationDataFim(correcao) {
      return correcao.recommendation.data_termino;
    }

    function canManage(aplicacao) {
      const aplicacaoProcessada = aplicacao && aplicacao.situacao !== 'pendente';
      const { correcaoSolo } = $rootScope.permissions;

      return correcaoSolo.canManage && correcaoSolo.canEditDelete && aplicacaoProcessada;
    }

    function showAreaDemarcada(correcao) {
      if (!correcao.areaVisivel) {
        correcao.areaVisivel = true;

        if (correcao.allData.has_area_demarcada) {
          correcao.polygons = DrawPolygonsObjectService
            .convertToObject(correcao.allData.area_demarcada || {}, true)
            .polygons;

          // Utilizado weight pois este polígono é montado pelo leafletjs
          // https://leafletjs.com/reference-1.2.0.html#polygon
          correcao.polygons.forEach(({ options }) => {
            options.weight = 7;
            options.strokeWeight = 7;
          });

          activePolygons = activePolygons.concat(correcao.polygons);
          $scope.$emit('addPolygons', correcao.polygons);
          const map = LeafletService.getMap('propriedade-map');
          map.fitBounds(correcao.polygons.map(function(polygon) {
            return polygon.getBounds();
          }));
        }
      } else {
        clearMapPolygons();
        correcao.areaVisivel = false;
      }
    }

    function activeHeatmaps(correcao) {
      const { polylines } = correcao;

      if (!polylines.length) {
        return [];
      }

      $route.updateParams({
        heatmaps: 'pulverizacao'
      });
      $scope.$emit('setActiveHeatmaps', {
        heatmaps: [{ ...correcao, title: 'Aplicação de correção de solo visível' }],
        mapType: 'aplicacao'
      });
      const start = polylines[0].coordinate;
      const end = polylines[polylines.length - 1].coordinate;
      const startEndMarkers = MapaService.createStartEndMarkers(start, end);
      $scope.$emit('setMarkers', startEndMarkers);
      renderPolylines(polylines);
    }

    function getPolylines(data, correcao) {
      const polylines = MapaService.getLeafletPolylineWithObject({
        pontos: data,
        faixas: correcao.allData.faixas_velocidade
      });
      polylines.forEach((polyline) => {
        polyline.decorator = L.polylineDecorator(polyline, {
          patterns: [
            {
              offset: 20,
              repeat: 50,
              symbol: L.Symbol.arrowHead({
                pixelSize: 7,
                polygon: false,
                pathOptions: {
                  stroke: true,
                  color: polyline.options.color
                }
              })
            }
          ]
        });
      });

      return polylines;
    }

    function showRastroMaquina(correcao) {
      if (!correcao.polylines) {
        $http.get(`${SERVER}v1/aplicacoes/${correcao.id}/tracking`).then(function(response) {
          const data = response.data;

          if (data.length > 0) {
            correcao.polylines = getPolylines(data, correcao);
            activeHeatmaps(correcao);
          } else {
            correcao.polylines = [];
          }
        });
      } else {
        activeHeatmaps(correcao);
      }
    }

    function renderPolylines(polylines) {
      $scope.$emit('setPolylines', polylines);
      const map = LeafletService.getMap('propriedade-map');
      polylines.forEach((polyline) => {
        polyline.decorator.addTo(map);
      });
      map.fitBounds(polylines.map(function(polyline) {
        return polyline.getBounds();
      }));

      polylines.forEach(function(polyline) {
        polyline.bindPopup(createInfoWindow(null, polyline));
      });
    }

    function resetMap() {
      $scope.applications.forEach((application) => {
        application.areaVisivel = false;
      });
      clearMapPolygons();
      closeApplicationsAreaVisivel();
    }

    function setFilterAttribute(attribute, object, event) {
      preventDefault(event);
      $scope.initializeVariables();
      $scope.correcoesFilters[attribute] = object;
      $scope.getApplications();
    }

    function openPeriodsFilter(event) {
      preventDefault(event);
      PeriodSelectService.openPeriodSelection($scope.period, $scope.correcoesFilters).then(function() {
        $scope.setPeriodo();
      });
    }

    function toggleStatusFilter(status, event) {
      stopPropagation(event);
      preventDefault(event);
      $scope.statusFilter[status] = !$scope.statusFilter[status];
      $scope.initializeVariables();
      $scope.correcoesFilters.status = buildStatusParam($scope.statusFilter);
      $scope.getApplications();
    }

    function getStatusFilterLabel() {
      const statusLabels = { integrado: 'Integrado', erro: 'Erro', pendente: 'Pendente' };
      const chaves = Object.keys(statusLabels);
      const selecionadas = chaves.filter((chave) => $scope.statusFilter[chave]);

      if (selecionadas.length === 0 || selecionadas.length === chaves.length) {
        return 'Status';
      }
      return selecionadas.map((chave) => statusLabels[chave]).join(', ');
    }

    function buildStatusParam(statusFilter) {
      const statusParaApi = { integrado: 'finalizado', erro: 'erro', pendente: 'pendente' };
      const selecionadas = Object.keys(statusParaApi).filter((chave) => statusFilter[chave]);
      return selecionadas.length ? selecionadas.map((chave) => statusParaApi[chave]).join(',') : null;
    }

    function setPeriodo(periodo, event) {
      preventDefault(event);
      $scope.initializeVariables();
      if (periodo) {
        $scope.correcoesFilters.dataInicial = periodo.dataInicial;
        $scope.correcoesFilters.dataFinal = periodo.dataFinal;
        $scope.period.periodo = periodo.descricao;
      }
      $scope.getApplications();
    }

    function remover(correcao) {
      MessagesService.confirm('Deseja realmente excluir a correção de solo?').then(function() {
        LoadingService.showLoading();
        CorrecoesSoloService.delete(correcao.id).then(function() {
          MessagesService.alert('Correção de solo excluída com sucesso.');
          $route.reload();
        })
          .catch(function(error) {
            let message = 'Falha ao excluir correção de solo';
            if (_.get(error.data, 'message')) {
              message = `${message}: ${error.data.message}`;
            }
            MessagesService.alert(message);
            console.error('Falha ao excluir correção de solo', error);
          })
          .finally(LoadingService.hideLoading);
      });
    }

    function calculateTotalProduto(produto, areaGleba, shouldRecalculate) {
      const dose = produto.dose || produto.qt_dose;
      const quantidadeTotal = dose * areaGleba;

      if (DecimalsService.isDecimalV2Enabled()) {
        const quantidadeTotalProduto = Math.max(+produto.qt_total, 0) > 0 && !shouldRecalculate ?
          +produto.qt_total :
          quantidadeTotal;

        return DecimalsService.formatDoseOrQuantityForDisplay(quantidadeTotalProduto);
      }

      return quantidadeTotal;
    }

    function getRecommendationProducts(correcao) {
      return (correcao.recommendation || {}).produtos;
    }

    function createInfoWindow(event, polygon) {
      const content = TrackingService.getContentInfoWindow(polygon);
      return `<div class="simple-popup">
                ${content}
              </div>`;
    }

    function edit(application) {
      $scope.$emit('activateSidebar', 'editApplication', application);
    }

    function closeRecommendations() {
      ($scope.applications || []).forEach(function(application) {
        application.openRecommendation = false;
      });
      $scope.$apply();
    }

    function clearMapPolygons() {
      if (activePolygons.length > 0) {
        $scope.$emit('removePolygons', activePolygons);
        activePolygons = [];
      }
    }

    function closeApplicationsAreaVisivel() {
      $scope.applications.forEach((aplicacao) => {
        if (aplicacao.areaVisivel) {
          aplicacao.areaVisivel = false;
        }
      });
    }

    function filterHasChanges() {
      const { gleba, dataInicial } = $scope.correcoesFilters;
      const { activeGleba, historyDate } = $routeParams;

      const filterGlebaChanged = activeGleba && +activeGleba !== (gleba || {}).id;
      const filterDateChanged = historyDate && historyDate !== dataInicial;

      return !!(filterGlebaChanged || filterDateChanged);
    }

    //////////////////////////////////////////
    // Controller logic

    $scope.$on('$destroy', resetMap);

    $scope.$on('correcaoSoloActivate', $scope.initialize);

    $scope.$on('correcaoDeactivate', resetMap);

    $scope.$on('applications_close', function() {
      $scope.resetMap();
      $scope.applications = [];
    });

    $scope.$on('$routeUpdate', () => {
      RecomendacoesService.routeUpdateFunction($scope, $routeParams);

      if ($scope.correcoesFilters && filterHasChanges()) {
        $scope.initializeVariables();
        $scope.setValoresComBaseNoHistorico();
        $scope.getApplications();
      }

      if ($routeParams.activeApplicationsTab !== 'correcaoSolo' && activePolygons.length > 0) {
        resetMap();
      }
    });
  }
}());
